import { HttpClient } from '@angular/common/http';
import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CONTRACT_ROLES, RSP_ROLES, ROLE_NAME } from '../../shared/enums/admin-enum';
import { ProfileService } from '../../shared/service/profile.service';

@Component({
  selector: 'app-landing-page-hydro',
  templateUrl: './landing-page-hydro.component.html',
  styleUrls: ['./landing-page-hydro.component.scss']
})
export class LandingPageHydroComponent implements OnInit {
  roles = [];
  roleName: string;
  userName: string;

  constructor(private profileService: ProfileService) {
    this.roles = atob(localStorage.getItem(btoa('role'))).split(',');
    this.roleName = this.roles.map(role => ROLE_NAME[role]).toString();
    this.profileService.getProfileUser().subscribe((res: any) => {
      // this.spinner.hide(); // ???
      if (res && res.data.roles.findIndex(i => i === 'GUEST') === -1) {
        this.userName = res.data.fullName;
        const primaryRole = res.data.primaryRole === 'CONTRACT' ? this.roles.filter(r => CONTRACT_ROLES[r])[0]
        : this.roles.filter(r => RSP_ROLES[r])[0];
        this.roleName = ROLE_NAME[primaryRole];
        this.countVisitor(res.data.sso);
      } else {
        this.getIp();
      }
    });
  }
  ngOnInit() {
    
  }
  @HostListener('window:focus', ['$event'])
    onFocus(event: any): void {
      if (!this.userName) {
        if (localStorage.getItem(btoa('userName'))) this.userName = decodeURIComponent(escape(atob(localStorage.getItem(btoa('userName')))));
        if (localStorage.getItem(btoa('role'))) this.roleName = atob(localStorage.getItem(btoa('role')));
      }
    }
  logOut() {
    localStorage.removeItem(btoa('userName'));
    localStorage.removeItem(btoa('role'));
    window.location.href = '/logout';
  }
  goPageRegister() {
    window.open('https://registration.gepower.com/');
  }

  countVisitor(uid) {
    console.log(uid);
    this.profileService.countVisitor(uid).subscribe();
  }

  getIp() {
    this.profileService.getIp().subscribe((res: any) => {
      this.countVisitor(res.ip);
    });
  }
}
